import isNumber from 'lodash/isNumber'

/**
 * Блокирует/разблокирует скролл body и popup
 * @param {jQuery} $el элемент блокировки скролла.
 * @param {boolean} [isLock] Признак блокировки скролла.
 * @param {boolean} [withScrollPosition] Признак сохранения прокрутки
 * @param {number} [scrollPosition=0] Значение координат скролла
 * @returns {number} [scrollTopPosition] Возвращает координаты скролла
 */
export function toggleViewLock ($el, isLock, withScrollPosition, scrollPosition = 0) {
  const noBackScrollClass = 'no-back-scroll-modify'
  if (isLock === undefined) {
    isLock = !$el.hasClass(noBackScrollClass)
  }

  if (isLock) {
    if (withScrollPosition) {
      const scrollTopPosition = $(document).scrollTop()
      $el.addClass(noBackScrollClass)
      return scrollTopPosition
    }
    $el.addClass(noBackScrollClass)
  } else {
    $el.removeClass(noBackScrollClass)
    if (withScrollPosition && isNumber(scrollPosition)) {
      $(document).scrollTop(scrollPosition)
    }
  }
}
